const API_BASE = '/api';

export const loadAssets = async () => {
  try {
    const res = await fetch(`${API_BASE}/assets`);
    if (!res.ok) throw new Error('Failed to load assets');
    return await res.json();
  } catch (error) {
    console.error('Error loading assets:', error);
    return [];
  }
};

export const saveAssets = async (assets) => {
  try {
    const res = await fetch(`${API_BASE}/assets`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(assets)
    });
    if (!res.ok) throw new Error('Failed to save assets');
  } catch (error) {
    console.error('Error saving assets:', error);
  }
};

export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const loadAssetTypes = async () => {
  try {
    const res = await fetch(`${API_BASE}/asset-types`);
    if (!res.ok) throw new Error('Failed to load asset types');
    return await res.json();
  } catch (error) {
    console.error('Error loading asset types:', error);
    return [];
  }
};

export const saveAssetTypes = async (assetTypes) => {
  try {
    const url = `${API_BASE}/asset-types`;
    console.log('Sending PUT request to:', url);
    const res = await fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(assetTypes)
    });
    console.log('Response status:', res.status, res.statusText);
    if (!res.ok) {
      const errorText = await res.text();
      let errorData = {};
      try {
        errorData = JSON.parse(errorText);
      } catch {
        errorData = { error: errorText || `HTTP ${res.status}: ${res.statusText}` };
      }
      throw new Error(errorData.error || 'Failed to save asset types');
    }
    return await res.json();
  } catch (error) {
    console.error('Error saving asset types:', error);
    throw error; // Re-throw so the caller can handle it
  }
};

/**
 * Upload a file (image or document) for an asset
 */
export const uploadFile = async (assetId, file, fileType = 'document') => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileType', fileType);

    const res = await fetch(`${API_BASE}/assets/${assetId}/upload`, {
      method: 'POST',
      body: formData
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || 'Failed to upload file');
    }

    return await res.json();
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

/**
 * Delete a file for an asset
 */
export const deleteFile = async (assetId, filename, fileType = 'document') => {
  try {
    const res = await fetch(`${API_BASE}/assets/${assetId}/files/${encodeURIComponent(filename)}?type=${fileType}`, {
      method: 'DELETE'
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || 'Failed to delete file');
    }

    return await res.json();
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};

/**
 * Load contractors from API
 */
export const loadContractors = async () => {
  try {
    const res = await fetch(`${API_BASE}/contractors`);
    if (!res.ok) throw new Error('Failed to load contractors');
    return await res.json();
  } catch (error) {
    console.error('Error loading contractors:', error);
    return [];
  }
};

/**
 * Create a new contractor
 */
export const createContractor = async (contractor) => {
  try {
    const res = await fetch(`${API_BASE}/contractors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(contractor)
    });
    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || 'Failed to create contractor');
    }
    return await res.json();
  } catch (error) {
    console.error('Error creating contractor:', error);
    throw error;
  }
};

/**
 * Update a contractor
 */
export const updateContractor = async (id, contractor) => {
  try {
    const res = await fetch(`${API_BASE}/contractors/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(contractor)
    });
    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || 'Failed to update contractor');
    }
    return await res.json();
  } catch (error) {
    console.error('Error updating contractor:', error);
    throw error;
  }
};

/**
 * Delete a contractor
 */
export const deleteContractor = async (id) => {
  try {
    const res = await fetch(`${API_BASE}/contractors/${id}`, {
      method: 'DELETE'
    });
    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || 'Failed to delete contractor');
    }
    return await res.json();
  } catch (error) {
    console.error('Error deleting contractor:', error);
    throw error;
  }
};


